import { Button } from "components/DesignSystem/Button/Button";
import { FeatureDetails } from "components/FeatureDetails/FeatureDetails";
import { useCurrentEntityId } from "hooks/useCurrentEntityId";
import { useCurrentGroupContext } from "hooks/useCurrentGroupContext";
import { useModal } from "hooks/useModal";
import { LockDescription } from "pages/Books/RevenueMetrics/RevenueMetricsLocked";
import { TaxSubscriptionModal } from "pages/Tax/TaxSubscriptionModal";
import AuditLogs from "static/images/BannerAuditLogV2.png";

export const LockedAuditLogs = () => {
  const entityId = useCurrentEntityId();
  const { uuid: groupId } = useCurrentGroupContext();

  const subscriptionModal = useModal();

  const descriptionText =
    "Track all user activity across your account ensuring transparency, and accountability";
  return (
    <section className="t-flex t-justify-center t-items-center t-h-full t-w-full">
      <FeatureDetails
        banner={
          <img
            className="t-w-[22.5625rem] t-h-[13.5rem] t-object-cover"
            src={AuditLogs}
            alt="AuditLogs"
          />
        }
        description={
          <LockDescription
            descriptionText={descriptionText}
            title="Audit Logs"
          />
        }
        button={
          <Button
            onClick={() => subscriptionModal.open()}
            customType="primary"
            size="regular"
          >
            Upgrade to Inkle Tax Standard
          </Button>
        }
      />
      <TaxSubscriptionModal
        show={subscriptionModal.isOpen}
        onClose={() => subscriptionModal.close()}
        entityId={entityId}
        groupId={groupId}
        description={
          <div className="t-pt-1 t-pb-4 t-text-subtext t-text-text-60">
            Unlock access to Audit logs and more with Tax Standard Plan
          </div>
        }
      />
    </section>
  );
};
